import React, { FC } from 'react';
import { BoxV2 as Box } from 'portal-commons';

const BlockDivider: FC = () => (
  <Box
    sx={{
      width: '100%',
      height: '1px',
      bg: '#cccfd0',
    }}
  />
);

export default BlockDivider;
